import { render, staticRenderFns } from "./EventQueue.vue?vue&type=template&id=2ada4a1f&scoped=true"
import script from "./EventQueue.vue?vue&type=script&lang=ts"
export * from "./EventQueue.vue?vue&type=script&lang=ts"
import style0 from "./EventQueue.vue?vue&type=style&index=0&id=2ada4a1f&prod&lang=scss&scoped=true"
import style1 from "./EventQueue.vue?vue&type=style&index=1&id=2ada4a1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada4a1f",
  null
  
)

export default component.exports